<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pVI"></a><a id="pVII"></a>Contents</p>
<p class="contents-ct"><a href="#/ch1.htm#chap1"><span class="contentblock"><span class="fsc">ONE</span></span>The God of No Foreign War</a></p>
<p class="contents-ct"><a href="#/ch2.htm#chap2"><span class="contentblock"><span class="fsc">TWO</span></span>Lousy November</a></p>
<p class="contents-ct"><a href="#/ch3.htm#chap3"><span class="contentblock"><span class="fsc">THREE</span></span>Plan Dog</a></p>
<p class="contents-ct"><a href="#/ch4.htm#chap4"><span class="contentblock"><span class="fsc">FOUR</span></span>Cruising in December</a></p>
<p class="contents-ct"><a href="#/ch5.htm#chap5"><span class="contentblock"><span class="fsc">FIVE</span></span>The Arsenal of Ideas</a></p>
<p class="contents-ct"><a href="#/ch6.htm#chap6"><span class="contentblock"><span class="fsc">SIX</span></span>Make the Army Roll</a></p>
<p class="contents-ct"><a href="#/ch7.htm#chap7"><span class="contentblock"><span class="fsc">SEVEN</span></span>Have We the Vision?</a></p>
<p class="contents-ct"><a href="#/ch8.htm#chap8"><span class="contentblock"><span class="fsc">EIGHT</span></span>Joint Talks</a></p>
<p class="contents-ct"><a href="#/ch9.htm#chap9"><span class="contentblock"><span class="fsc">NINE</span></span>The Flames of World Conflagration Lick Everywhere</a></p>
<p class="contents-ct"><a href="#/ch10.htm#chap10"><span class="contentblock"><span class="fsc">TEN</span></span>The Third Hundred Days</a></p>
<p class="contents--"><a href="#/notes.htm#notes"><i>Notes</i></a></p>
<p class="contents"><a href="#/acknowledgments.htm#ack"><i>Acknowledgments</i></a></p>
<p class="contents"><a href="#/credits.htm#cred"><i>Credits</i></a></p>
<p class="contents"><a href="#/index.htm#index"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?456cf4ea